import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Button } from './ui/Button';
export function StickyHeader() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show header after scrolling down 600px (past hero)
      if (window.scrollY > 600) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToOffer = () => {
    const target = document.getElementById('offer');
    if (!target) return;
    const targetPosition = target.getBoundingClientRect().top + window.scrollY;
    const startPosition = window.scrollY;
    const distance = targetPosition - startPosition;
    const duration = 2000;
    let startTime: number | null = null;
    function animation(currentTime: number) {
      if (startTime === null) startTime = currentTime;
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const ease = progress < 0.5 ? 4 * progress * progress * progress : 1 - Math.pow(-2 * progress + 2, 3) / 2;
      window.scrollTo(0, startPosition + distance * ease);
      if (progress < 1) {
        requestAnimationFrame(animation);
      }
    }
    requestAnimationFrame(animation);
  };
  return <AnimatePresence data-id="element-257">
      {isVisible && <motion.header initial={{
      y: -100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: -100,
      opacity: 0
    }} transition={{
      duration: 0.3
    }} className="fixed top-0 left-0 right-0 z-50 bg-slate-950/90 backdrop-blur-md border-b border-slate-800 shadow-xl" data-id="element-258">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between" data-id="element-259">
            <div className="font-heading font-bold text-xl text-white tracking-wider hidden sm:block" data-id="element-260">
              THE NO-KNEE TAX LADDER
            </div>
            <div className="font-heading font-bold text-xl text-white tracking-wider sm:hidden" data-id="element-261">
              NO-KNEE TAX
            </div>

            <div className="flex items-center gap-4" data-id="element-262">
              <span className="text-slate-400 font-medium hidden md:block" data-id="element-263">
                Joint-Safe Fat Loss for Men 50+
              </span>
              <Button variant="primary" size="sm" onClick={scrollToOffer} className="shadow-none" data-id="element-264">
                Get the Blueprint — $6.36
              </Button>
            </div>
          </div>
        </motion.header>}
    </AnimatePresence>;
}